export default __webpack_public_path__ + "static/media/Icon material-timeline.924eb2d6.svg";